import React, { useState, useEffect } from 'react';
import './App.css';
import TemperatureSet from './TemperatureSet'; // Import the TemperatureSet component.
import TemperatureGraph from './TemperatureGraph'; // Import the TemperatureGraph component.
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n.js' 
import { useTranslation } from "react-i18next";

function App() {

  const { t } = useTranslation();
  // Assume you have fetched temperature data and stored it in a state variable.
  const [temperatureData, setTemperatureData] = useState({});

  // Fetch data from the API and set it in the state using useEffect.
  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API;

    // Fetch data from the API
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        
        setTemperatureData(data);
      })
      .catch(error => {
        // Handle errors here, e.g., set an error state or display an error message
        console.error('Error fetching data:', error);
      });
    //setTemperatureData({latest: {air: { current: "20.4", max: "25", min: "19"}, water: {}}, week: []});
    //console.log(temperatureData)
  }, []); // Ensure this effect runs only once on component mount.
  
  return (
    <main>
      <div className="px-4 py-5">
    
      <h1 className="display-5 fw-bold text-body-emphasis text-center pb-5">{t("headerTitle")}</h1>
      
      {/* Render the TemperatureSet component */}
      <TemperatureSet temperatureData={temperatureData} />
      
     
      {/* Render the TemperatureGraph component */}
      <TemperatureGraph temperatureData={temperatureData} />
      
      </div>
    </main>
  );
}

export default App;
